import * as React from 'react';
import { Agency16, Agent24, Images16, User16, Bank16, Zastroishik16 } from '../../../../icons';
export function AvatarFallbackIcon(_ref) {
  var type = _ref.type;
  var Icon = getIconComponent(type);
  return /*#__PURE__*/React.createElement(Icon, {
    color: "current_color"
  });
}
export function getIconComponent(type) {
  switch (type) {
    case 'user':
    case 'homeowner':
      return User16;
    case 'agent':
      return Agent24;
    case 'builder':
      return Zastroishik16;
    case 'agency':
      return Agency16;
    case 'bank':
      return Bank16;
    default:
      return Images16;
  }
}